<template>
  <div class="duration-options">
    <div class="header">
      <h2>{{ selectedProduct.name }}</h2>
      <p>{{ sortedProducts[0].period ? 'Kies abonnementsduur' : 'Kies abonnement' }}</p>
    </div>
    <div class="duration-buttons">
      <div
        v-for="(product, i) in sortedProducts"
        :key="i"
        :class="{'has-label': hasLabel(i)}"
        class="button-container"
      >
        <duration-button
          :duration="product.period ? productDurationsLabels[product.period] : product.name"
          :price="product.period ? periodPricesAfterDiscount[product.period] : product.total_price.value"
          :monthly="!!product.period"
          :is-active="product.id === selectedProduct.id"
          :label="hasLabel(i) && product.period ? 'Meeste voordeel' : ''"
          @click="SET_SELECTED_PRODUCT_ID(product.id)"
        />
      </div>
    </div>
    <h3 class="total">
      Totaal:
      {{ totalPriceAfterDiscount | localize }}
      <span v-if="totalPriceAfterDiscount !== totalPrice">{{ totalPrice | localize }}</span>
    </h3>
  </div>
</template>

<script>
  import { createNamespacedHelpers } from 'vuex'
  import DurationButton from './DurationButton'

  export default {
    components: {
      DurationButton
    },
    props: {
      namespace: {
        type: String,
        required: true
      }
    },
    beforeCreate () {
      const namespace = this.$options.propsData.namespace
      const { mapState, mapGetters, mapMutations } = createNamespacedHelpers(namespace)
      // computed
      this.$options.computed = {
        ...(this.$options.computed || {}),
        ...mapState([
          'products'
        ]),
        ...mapGetters([
          'selectedProduct',
          'productDurationsLabels',
          'selectedDuration',
          'totalPrice',
          'totalPriceAfterDiscount',
          'periodPricesAfterDiscount',
          'sortedProducts'
        ])
      }
      // methods
      this.$options.methods = {
        ...(this.$options.methods || {}),
        ...mapMutations(['GOTO_STEP', 'SET_SELECTED_PRODUCT_ID'])
      }
    },
    methods: {
      hasLabel (i) {
        // last button if more than one duration exists
        return this.sortedProducts.length > 1 && i === this.sortedProducts.length - 1
      }
    }
  }
</script>

<style lang="scss" scoped>

  @import '../assets/styles/_variables.scss';
  @import '../assets/styles/_mixins.scss';

  .duration-options {
    width: 100%;
    margin: 0 auto;
    text-align: center;
    padding: 0 1.5em;

    @include screen(md) {
      width: 8 / 10 * 100%;
      padding: 0;
    }

  }

  .header {
    padding-bottom: 1.5em;

    @include screen(md) {
      padding-bottom: 2em;
    }

    h2 {
      font-size: 1.5em;
      line-height: 1.33;
      margin-bottom: .5em;

      @include screen(md) {
        font-size: 2.25em;
        line-height: 1.2;
      }

    }

    p {
      color: var(--ec-gray, lighten(black, 35));
    }
  }

  .duration-buttons {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    margin: 0 -1em .5em -1em;

    @include screen(md) {
      margin: 0 -.5em 2em -.5em;
    }

  }

  .button-container {
    padding: 0 .5em 1em .5em;
    flex: 0 1 100%;

    @include screen(md) {
      flex: 0 0 1 / 4 * 100%;
    }

    &.has-label {
      margin-top: 15px;

      @include screen(md) {
        margin-top: 0;
      }

    }

  }

  .total {
    font-size: 1.5em;
    margin: 0;
    padding-bottom: 1.5em;

    @include screen(md) {
      padding-bottom: 3em;
    }

    span {
      font-size: 1.125rem;
      font-weight: 400;
      color: var(--ec-red, red);
      text-decoration: line-through;
    }

  }

</style>
